export const SELECTED_CONTINUITY_SCHEMA = 'sportsnew-selected-cut/v1';
/** @typedef {number & {readonly __sequence: unique symbol}} SelectedSequence */
/** The socket, session and existing membership own identity; no client-generated authority. */
export const sameSelectedOwner = (a, b) => !!a && !!b
  && ['socket', 'session', 'generation', 'mode', 'scope', 'selectionKey', 'room', 'supported']
    .every(key => a[key] === b[key]);
/** @returns {SelectedSequence | null} */
export const selectedSequence = value => Number.isSafeInteger(value) && value > 0
  ? /** @type {SelectedSequence} */ (value) : null;

export const validSelectedCut = (cut, owner, since) => cut?.status === true && cut.ok === true
  && cut.room === owner.room && cut.from === since
  && Number.isSafeInteger(cut.membershipRevision) && cut.membershipRevision >= 0
  && Number.isSafeInteger(cut.through) && cut.through >= since
  && Array.isArray(cut.deltas) && cut.deltas.length <= 100
  && cut.deltas.length === cut.through - since
  && cut.deltas.every((row, index) => row.sequence === since + index + 1
    && row.event === 'sportsnew:selected:patch' && row.patch?.room === owner.room);
